// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAttachmentOutlinedSvg from "@fishx/icons-svg/es/asn/PAttachmentOutlined";
import FishxIcon from '../components/FishxIcon';

var PAttachmentOutlined = function PAttachmentOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAttachmentOutlinedSvg
  }));
};

PAttachmentOutlined.displayName = 'PAttachmentOutlined';
export default React.forwardRef(PAttachmentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAttachmentOutlined.js
// module id = 3224
// module chunks = 0